import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { FiEdit, FiFolder, FiMoreVertical, FiTrash2 } from "react-icons/fi";
import { MediaType } from "../../../generated/graphql";
import type { MediaItem } from "../types";

interface ThreeDotMenuProps {
  media: MediaItem;
  onEdit: () => void;
  onMove: () => void;
  onDelete: () => void;
}

export function ThreeDotMenu({ media: _media, onEdit, onMove, onDelete }: ThreeDotMenuProps) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton className="flex items-center justify-center w-6 h-6 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors">
        <FiMoreVertical className="h-5 w-5" />
      </MenuButton>

      <MenuItems className="absolute right-0 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
        <div className="py-1">
          <MenuItem>
            {({ focus }) => (
              <button
                type="button"
                onClick={onEdit}
                className={`${
                  focus ? "bg-gray-100" : ""
                } group flex w-full items-center px-4 py-2 text-sm text-gray-700`}
              >
                <FiEdit className="mr-3 h-4 w-4" aria-hidden="true" />
                Edit metadata
              </button>
            )}
          </MenuItem>

          <MenuItem>
            {({ focus }) => (
              <button
                type="button"
                onClick={onMove}
                className={`${
                  focus ? "bg-gray-100" : ""
                } group flex w-full items-center px-4 py-2 text-sm text-gray-700`}
              >
                <FiFolder className="mr-3 h-4 w-4" aria-hidden="true" />
                Move to folder
              </button>
            )}
          </MenuItem>

          <div className="border-t border-gray-100" />

          <MenuItem>
            {({ focus }) => (
              <button
                type="button"
                onClick={onDelete}
                className={`${
                  focus ? "bg-red-50" : ""
                } group flex w-full items-center px-4 py-2 text-sm text-red-600`}
              >
                <FiTrash2 className="mr-3 h-4 w-4" aria-hidden="true" />
                Move to trash
              </button>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
}
